module.exports = __webpack_public_path__ + "static/img/hb_46-min.bce18d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_46-min.png
// module id = 3wWk
// module chunks = 1